import { PolicyNote } from '@r1-frontend/ui-react/components/PolicyNote';
import React, { useEffect, useState } from 'react';

import { POLICY_PAGE_LINK } from '~/src/constants';

import { Button, Buttons, Fields, Name, Phone } from './styled';

const PopupForm = (
    {
        onSubmit = () => {},
        isLoading = false,
    },
) => {

    const [phone, setPhone] = useState({});
    const [name, setName] = useState({});
    const [isValidInputs, setIsValidInputs] = useState(false);

    useEffect(() => {
        setIsValidInputs(phone.isValid && name.isValid);
    }, [phone, name]);

    const buttonText = 'Оставить заявку';

    return (
        <>
            <Fields>
                <Name
                    name='name'
                    onChange={stateInput => setName(stateInput)}
                    placeholder='ФИО'
                    errorMessage='Ожидаются только буквы и дефисы'
                    className={'ym-disable-keys'}
                />
                <Phone
                    name='phone'
                    onChange={stateInput => setPhone(stateInput)}
                    placeholder='Номер телефона'
                    errorMessage='Введите телефон в формате +7 (999) 999-99-99'
                    className={'ym-disable-keys'}
                />
            </Fields>
            <Buttons>
                <Button
                    text={buttonText}
                    onClick={() => {
                        onSubmit(name.value, phone.value);
                    }}
                    disabled={!isValidInputs || isLoading}
                />
            </Buttons>
            <PolicyNote
                data-test='agreement'
                buttonText={buttonText}
                agreeUrl={POLICY_PAGE_LINK}
            />
        </>
    );
};

export default PopupForm;
